import {KeycloakPromise} from 'keycloak-js';
import {AuthLifecycle, AuthStrategy} from './auth-strategy.types';
import {AuthState, Profile} from './auth.types';

export const SESSION_TOKEN_KEY = 'e2e_access_token';

const E2E_PROFILE: Profile = {
  preferredName: 'E2E User',
  department: 'e2e',
  avatarUrl: '',
};

/**
 * Keycloak-free session for the local Playwright suite: the token is put into
 * sessionStorage before the app boots (see e2e/ui/browser-session.ts).
 */
export class SessionTokenAuthStrategy implements AuthStrategy {
  private token: string | null = null;

  public constructor(private readonly lifecycle: AuthLifecycle) {
    this.token = this.readToken();
    // Synchronous: PrivateRoute must not bounce to /sign-in before the token is seen.
    this.lifecycle.initialized.next(true);
    this.lifecycle.authenticated.next(Boolean(this.token));
  }

  public login(): void {
    this.token = this.readToken();
    this.lifecycle.authenticated.next(Boolean(this.token));
  }

  public logout(): void {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
    this.token = null;
    this.lifecycle.authenticated.next(false);
  }

  public updateToken(): KeycloakPromise<boolean, boolean> {
    this.token = this.readToken();
    return Promise.resolve(true) as KeycloakPromise<boolean, boolean>;
  }

  public get authState(): AuthState {
    const token = this.token || this.readToken() || '';
    return {
      accessToken: token,
      refreshToken: token,
      idToken: token,
    };
  }

  public get userProfile(): Profile {
    return E2E_PROFILE;
  }

  private readToken(): string | null {
    return sessionStorage.getItem(SESSION_TOKEN_KEY);
  }
}
